<div class="secao-participante" [class.card-lateral]="!plano()">
    <p-table [value]="participantes()" styleClass="tabela-lateral" [tableStyle]="{ 'min-width': '100%' }" [scrollable]="true" [scrollHeight]="scrollHeight()">
        <ng-template pTemplate="header">
            <tr>
                @if (mostrarAvatar()) {
                    <th class="col-avatar" aria-label="Foto"></th>
                }
                <th class="col-uf">UF</th>
                <th>{{ rotuloColuna() }}</th>
                <th class="text-center">Presente</th>
                <th class="text-center col-acoes">Ações</th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-participante>
            <tr>
                @if (mostrarAvatar()) {
                    <td class="col-avatar">
                        <app-pessoa-avatar [idSolicitante]="participante.idSolicitante" [uf]="participante.uf" [nome]="participante.nome" [tamanho]="tamanhoAvatar()"></app-pessoa-avatar>
                    </td>
                }
                <td class="col-uf">{{ participante.uf }}</td>
                <td>{{ participante.nome }}</td>
                <td class="text-center">
                    <i [class]="icone(participante.situacao) + ' text-base'" [ngClass]="classe(participante.situacao)" [title]="rotulo(participante)"></i>
                </td>
                <td class="text-center col-acoes">
                    <div class="botoes-acao">
                        <button
                            type="button"
                            pButton
                            icon="pi pi-file-plus"
                            severity="secondary"
                            [text]="true"
                            [rounded]="true"
                            size="small"
                            [disabled]="!permiteAlteracao()"
                            [appCan]="roleGerenciarConvidados"
                            (click)="inserirNaAta.emit(participante)"
                            title="Inserir na Ata"
                            aria-label="Inserir na Ata"
                        ></button>
                        <button
                            type="button"
                            pButton
                            icon="pi pi-pencil"
                            severity="secondary"
                            [text]="true"
                            [rounded]="true"
                            size="small"
                            [disabled]="!permiteAlteracao()"
                            [appCan]="roleGerenciarConvidados"
                            (click)="alterarPresenca.emit(participante)"
                            title="Alterar Presença"
                            aria-label="Alterar Presença"
                        ></button>
                        @if (permiteRemover()) {
                            <button
                                type="button"
                                pButton
                                icon="pi pi-trash"
                                severity="danger"
                                [text]="true"
                                [rounded]="true"
                                size="small"
                                [disabled]="!permiteAlteracao()"
                                [appCan]="roleGerenciarConvidados"
                                (click)="remover.emit({ participante, event: $event })"
                                title="Remover Convidado"
                                aria-label="Remover Convidado"
                            ></button>
                        }
                    </div>
                </td>
            </tr>
        </ng-template>
    </p-table>
</div>
